module.exports = __webpack_public_path__ + "img/iso-27001.87050575.png";